import { useQuery as useGetOwFApplication } from "@faire/web-api--source/endpoints/www/api/launch-with-faire/application/get-hooks";

export const useGetOwFApplicationStoreType = () => {
  const { data, isLoading } = useGetOwFApplication();

  return {
    owfStoreType: data?.best_store_type,
    isLoading: isLoading,
  };
};
